export const headerData = [
  'Name',
  'Company',
  'Type',
  'Sub Type',
  'Updated Date',
  '',
];
